import React from "react";
// REDUX
import { useSelector } from "react-redux";
// NAVIGATION
import { useLocation } from "react-router-dom";
// CUSTOM HOOKS
import useGetOneAdapter from "../../../../customHooks/GET_requests/useGetOneAdapter";
// COMPONENTS
import FaultConfiguration from "./FaultConfiguration";
// INTERFACES
import { RootState } from "../../../../app/store";

export default function FaultPage() {
  // ************************************************ */
  // GLOBAL VARIABLES ******************************* */
  const location = useLocation();
  const adapterId = new URLSearchParams(location.search).get("idAdapter");

  // ************************************************ */
  // USE STATE VARIABLES **************************** */

  // ************************************************ */
  // REDUX SLICE VARIABLES ************************** */
  const { theme } = useSelector((state: RootState) => state.home);

  // ************************************************ */
  // CUSTOM HOOKS *********************************** */
  const { adapter, isLoadingGetOneAdapter } = useGetOneAdapter({
    id: adapterId ?? "",
  });

  // ************************************************ */
  // HELPERS **************************************** */

  // ************************************************ */
  // SERVICES AND API CALLS ************************* */

  // ************************************************ */
  // USE MEMO *************************************** */

  // ************************************************ */
  // FUNCTIONS ************************************** */

  // ************************************************ */
  // USE CALLBACK *********************************** */

  // ************************************************ */
  // USE EFFECT ************************************* */

  // ************************************************ */
  // COMPONENT ************************************** */
  return (
    <div className={`layout__contentPage__${theme}`}>
      <FaultConfiguration isLoadingGetOneBank={isLoadingGetOneAdapter} adapter={adapter} />
    </div>
  );
}
